export const
    getSubgoal = (insuranceGoal) => {
        return {
            ...insuranceGoal
        };
    },
    getNote = (notes) => {
        return notes.find((note) => note.InsuranceType === 1);
    };
